import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconZap: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="zap, lightning, flash, thunder"><path d="M20.25 8.75H13.25V2.5L3.75 15.25H10.75V21.5L20.25 8.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconZap;
